export default defineNuxtPlugin(() => {
  const { id } = useRuntimeConfig().public.scripts.googleTagManager
  if (!id) {
    return
  }

  // CookieYes pushes consent only into a dataLayer that already exists, and GTM must read gtm.js before it, so the queue is created and seeded before consent.
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' })

  useAnalyticsScript({
    key: 'googleTagManager',
    src: `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(id)}`,
    storagePrefixes: [],
  })
})
